import type { AxiosError } from 'axios';

import type { Unauthenticated, Unauthorized } from '@campaign-manager/feature/lib/error';

import ErrorPane from '../ErrorPane';
import ErrorPageLayout from './ErrorPageLayout';

interface Props {
  error?: Error | AxiosError | Unauthenticated | Unauthorized;
  showPrimaryButton?: boolean;
  showReloadButton?: boolean;
}

export default function ErrorPage({ error, showPrimaryButton, showReloadButton }: Props) {
  return (
    <ErrorPageLayout>
      <ErrorPane
        error={error}
        showPrimaryButton={showPrimaryButton}
        showReloadButton={showReloadButton}
      />
    </ErrorPageLayout>
  );
}
